module.exports = __webpack_public_path__ + "static/media/decoration-line.e012d4ab.svg";